// =============================================================================
// LIGA AJUPAM — Copy único para "todavía no podés entrar acá" (v6.11.48)
// =============================================================================
// El mismo motivo se explica en tres lugares (el aviso del Inicio, el velo sobre
// Tabla/Partidos y el toast del nav). Tenerlo acá evita que se desincronicen y
// que el jugador lea tres versiones distintas de por qué no puede pasar.

import type { SectionLockReason } from './sectionAccess';

export interface LockCopy {
  /** Título corto, para el velo y el aviso. */
  heading: string;
  /** Una frase: qué pasa. */
  lead: string;
  /** Una frase: qué puede hacer al respecto. Vacío si no hay nada que hacer. */
  action: string;
  /** Versión de una línea para el toast del nav inferior. */
  toast: string;
}

export function getLockCopy(
  reason: SectionLockReason | null,
  opts: { regularPhaseStartDate?: string | null } = {}
): LockCopy {
  const startsOn = opts.regularPhaseStartDate
    ? (() => {
        try {
          return new Date(opts.regularPhaseStartDate + 'T00:00:00')
            .toLocaleDateString('es-AR', { day: 'numeric', month: 'short' });
        } catch {
          return null;
        }
      })()
    : null;

  switch (reason) {
    case 'DEBT':
      return {
        heading: 'Falta saldar la inscripción',
        lead: 'Tabla y Partidos quedan cerrados hasta que se acredite el pago completo.',
        action: 'Subí el comprobante desde Inicio y se destraba solo.',
        toast: 'Disponible cuando saldes la inscripción. Pagá desde Inicio.',
      };
    case 'NO_PARTNER':
      return {
        heading: 'Tu equipo todavía no está completo',
        lead: 'Sin compañero el equipo no entra en ninguna zona, así que no hay tabla ni partidos que mostrarte.',
        action: 'Pasale el código de invitación desde Inicio o Mi Equipo.',
        toast: 'Disponible cuando tu compañero se una. Invitalo desde Inicio.',
      };
    case 'MANUAL':
      return {
        heading: 'Tu equipo está bloqueado',
        lead: 'La organización bloqueó el acceso a las secciones de competencia mientras haya una situación pendiente.',
        action: 'Desde Inicio y Mi Equipo podés regularizar lo que falte o contactar al organizador.',
        toast: 'Tu equipo está bloqueado. Regularizá desde Inicio.',
      };
    case 'WAITLIST':
      return {
        heading: 'Estás en lista de espera',
        lead: 'Tu categoría estaba completa, así que todavía no competís: no tenés zona, tabla ni partidos.',
        action: 'Completá la pareja y aboná desde Inicio para mejorar tu posición en la lista.',
        toast: 'Estás en lista de espera. Mejorá tu posición desde Inicio.',
      };
    case 'PRE_SEASON':
      return {
        heading: 'Todavía no arrancó la fase regular',
        lead: startsOn
          ? `Esta sección se habilita cuando empiece la fase regular (prevista: ${startsOn}).`
          : 'Esta sección se habilita cuando empiece la fase regular.',
        action: 'Mientras tanto, dejá lista tu inscripción desde Inicio.',
        toast: startsOn
          ? `Disponible cuando arranque la fase regular (prevista: ${startsOn}).`
          : 'Disponible cuando arranque la fase regular.',
      };
    default:
      return {
        heading: 'Sección no disponible',
        lead: 'Todavía no podés acceder a esta sección.',
        action: '',
        toast: 'Sección no disponible por ahora.',
      };
  }
}
